import { faArrowLeft as faArrowLeftRegularSharp, faArrowRight as faArrowRightRegularSharp, faArrowUp as faArrowUpRegularSharp, faArrowUpRight as faArrowUpRightRegularSharp, faBan as faBanRegularSharp, faBold as faBoldRegularSharp, faCamera as faCameraRegularSharp, faCheck as faCheckRegularSharp, faChevronLeft as faChevronLeftRegularSharp, faChevronRight as faChevronRightRegularSharp, faCircleCheck as faCircleCheckRegularSharp, faCircleExclamation as faCircleExclamationRegularSharp, faCircle as faCircleRegularSharp, faCopyright as faCopyRightRegularSharp, faEnvelope as faEnvelopeRegularSharp, faFileArrowUp as faFileArrowUpRegularSharp, faFile as faFileRegularSharp, faFiles as faFilesRegularSharp, faInfoCircle as faInfoCircleRegularSharp, faItalic as faItalicRegularSharp, faListOl as faListOlRegularSharp, faListUl as faListUlRegularSharp, faPhone as faPhoneRegularSharp, faSearch as faSearchRegularSharp, faTrashCan as faTrashCanRegularSharp, faTrash as faTrashRegularSharp, faUnderline as faUnderlineRegularSharp, faUpload as faUploadRegularSharp, faUser as faUserRegularSharp, faXmarkCircle as faXMarkCircleRegularSharp, faXmark as faXMarkRegularSharp, } from "@fortawesome/sharp-regular-svg-icons";
import { faArrowRight as faArrowRightSharp, faBars as faBarsSolidSharp, faChevronDown as faChevronDownSharp, faChevronUp as faChevronUpSharp, faFileArrowUp as faFileArrowUpSolidSharp, faMinus as faMinusSharp, faPlus as faPlusSharp, faSpinner as faSpinnerSharp, faUser as faUserSolidSharp, } from "@fortawesome/sharp-solid-svg-icons";
var FaIcons;
(function (FaIcons) {
    FaIcons["Plus"] = "plus";
    FaIcons["Minus"] = "minus";
    FaIcons["ChevronDown"] = "chevron-down";
    FaIcons["ChevronUp"] = "chevron-up";
    FaIcons["ChevronLeftRegular"] = "chevron-left-regular";
    FaIcons["ChevronRightRegular"] = "chevron-right-regular";
    FaIcons["ArrowRight"] = "arrow-right";
    FaIcons["ArrowUpRight"] = "arrow-up-right";
    FaIcons["ArrowUp"] = "arrow-up";
    FaIcons["Spinner"] = "spinner";
    FaIcons["UserSolid"] = "user-solid";
    FaIcons["BarsSolid"] = "bars-solid";
    FaIcons["ArrowRightRegular"] = "arrow-right-regular";
    FaIcons["ArrowLeftRegular"] = "arrow-left-regular";
    FaIcons["XMarkRegular"] = "xmark";
    FaIcons["CircleRegular"] = "circle-regular";
    FaIcons["CircleCheckRegular"] = "circle-check-regular";
    FaIcons["CircleExclamationRegular"] = "circle-exclamation-regular";
    FaIcons["CircleXMarkRegular"] = "circle-xmark-regular";
    FaIcons["UploadRegular"] = "upload-regular";
    FaIcons["TrashRegular"] = "trash-regular";
    FaIcons["CheckRegular"] = "check-regular";
    FaIcons["InfoCircleRegular"] = "info-circle-regular";
    FaIcons["UserRegular"] = "user-regular";
    FaIcons["SearchRegular"] = "search-regular";
    FaIcons["PhoneRegular"] = "phone-regular";
    FaIcons["EnvelopeRegular"] = "envelope-regular";
    FaIcons["CameraRegular"] = "camera-regular";
    FaIcons["CopyrightRegular"] = "copy-right-regular";
    FaIcons["BoldRegular"] = "bold-regular";
    FaIcons["ItalicRegular"] = "italic-regular";
    FaIcons["UnderlineRegular"] = "underline-regular";
    FaIcons["ListUlRegular"] = "list-ul-regular";
    FaIcons["ListOlRegular"] = "list-ol-regular";
    FaIcons["FilesRegular"] = "files-regular";
    FaIcons["FileRegular"] = "file-regular";
    FaIcons["FileArrowUpRegular"] = "file-arrow-up-regular";
    FaIcons["FileArrowUpSolid"] = "file-arrow-up-solid";
    FaIcons["BanRegular"] = "ban-regular";
    FaIcons["TrashCanRegular"] = "trash-can-regular";
})(FaIcons || (FaIcons = {}));
const iconLookup = {
    [FaIcons.Plus]: faPlusSharp,
    [FaIcons.Minus]: faMinusSharp,
    [FaIcons.ChevronDown]: faChevronDownSharp,
    [FaIcons.ChevronUp]: faChevronUpSharp,
    [FaIcons.ChevronLeftRegular]: faChevronLeftRegularSharp,
    [FaIcons.ChevronRightRegular]: faChevronRightRegularSharp,
    [FaIcons.ArrowRight]: faArrowRightSharp,
    [FaIcons.ArrowUpRight]: faArrowUpRightRegularSharp,
    [FaIcons.ArrowUp]: faArrowUpRegularSharp,
    [FaIcons.Spinner]: faSpinnerSharp,
    [FaIcons.UserSolid]: faUserSolidSharp,
    [FaIcons.BarsSolid]: faBarsSolidSharp,
    [FaIcons.ArrowRightRegular]: faArrowRightRegularSharp,
    [FaIcons.ArrowLeftRegular]: faArrowLeftRegularSharp,
    [FaIcons.XMarkRegular]: faXMarkRegularSharp,
    [FaIcons.CircleRegular]: faCircleRegularSharp,
    [FaIcons.CircleCheckRegular]: faCircleCheckRegularSharp,
    [FaIcons.CircleExclamationRegular]: faCircleExclamationRegularSharp,
    [FaIcons.CircleXMarkRegular]: faXMarkCircleRegularSharp,
    [FaIcons.UploadRegular]: faUploadRegularSharp,
    [FaIcons.TrashRegular]: faTrashRegularSharp,
    [FaIcons.CheckRegular]: faCheckRegularSharp,
    [FaIcons.InfoCircleRegular]: faInfoCircleRegularSharp,
    [FaIcons.UserRegular]: faUserRegularSharp,
    [FaIcons.SearchRegular]: faSearchRegularSharp,
    [FaIcons.PhoneRegular]: faPhoneRegularSharp,
    [FaIcons.EnvelopeRegular]: faEnvelopeRegularSharp,
    [FaIcons.CameraRegular]: faCameraRegularSharp,
    [FaIcons.CopyrightRegular]: faCopyRightRegularSharp,
    [FaIcons.BoldRegular]: faBoldRegularSharp,
    [FaIcons.ItalicRegular]: faItalicRegularSharp,
    [FaIcons.UnderlineRegular]: faUnderlineRegularSharp,
    [FaIcons.ListUlRegular]: faListUlRegularSharp,
    [FaIcons.ListOlRegular]: faListOlRegularSharp,
    [FaIcons.FilesRegular]: faFilesRegularSharp,
    [FaIcons.FileRegular]: faFileRegularSharp,
    [FaIcons.FileArrowUpRegular]: faFileArrowUpRegularSharp,
    [FaIcons.FileArrowUpSolid]: faFileArrowUpSolidSharp,
    [FaIcons.BanRegular]: faBanRegularSharp,
    [FaIcons.TrashCanRegular]: faTrashCanRegularSharp,
};
export const toIconProp = (faIcon) => {
    const icon = iconLookup[faIcon];
    if (icon) {
        return icon;
    }
    return null;
};
export default FaIcons;
//# sourceMappingURL=faIcons.js.map